import { render, staticRenderFns } from "./ConceptsListGroupedByPhases.vue?vue&type=template&id=d63b73ec&"
import script from "./ConceptsListGroupedByPhases.vue?vue&type=script&lang=ts&"
export * from "./ConceptsListGroupedByPhases.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptsListGroupedByPhases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports